export { type MorphemeNote, morphemeNoteTable } from "#morpheme-note-table";
